import styled from 'styled-components';
import { palette } from 'styled-tools';
import { Img } from 'components';

export const CarContainer = styled.div`
    background: ${palette('gray_opacity_50')};
    box-sizing: border-box;
    border: 1px solid ${palette('gray_opacity_200')};
    border-radius: 8px;
`;

export const CarImage = styled(Img)`
    
`;
interface CarImageWrapperProps {
    backgroundImg?: string;
}
export const CarImageWrapper = styled.div<CarImageWrapperProps>`
    width: 100%;
    height: 240px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;    
    background: url('${props => props.backgroundImg ? props.backgroundImg : null}');
    background-size: cover;
`;

export const CarNumberWrapper = styled.div`
    display: flex;
    align-items: center;
    > label { 
        margin-right: 4px;
    }
`;

interface CarColorProps {
    backgroundColor?: string;
}

export const CarColor = styled.div<CarColorProps>`
    background: ${props => props.backgroundColor ? palette(props.backgroundColor) : palette('gray_opacity_100')};
    width: 16px;
    height: 16px;
    border-radius: 8px;
    border: 1px solid ${palette('gray_opacity_200')};
    box-sizing: border-box;
`;

export const CarInfoWrapper = styled.div`
    padding: 16px 20px;
`;